import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from './auth.service';

// Attaches the access token to Central API calls — the job angular-auth-oidc-client's
// authInterceptor did, now fed by our own AuthService. The auth endpoints themselves are skipped:
// they are the front door (no token yet), and the refresh call MUST pass untouched or refreshing
// a stale token would recurse into another refresh.
export const apiAuthInterceptor: HttpInterceptorFn = (req, next) => {
    if (!req.url.startsWith(environment.apiBaseUrl) || req.url.includes('/central/auth/')) {
        return next(req);
    }
    const auth = inject(AuthService);
    return from(auth.getAccessToken()).pipe(
        switchMap((token) => next(token ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }) : req))
    );
};
